import { Tabs, Pagination, Table, Empty } from '@bfe/moly';
import clx from 'classnames';

import { useData, useColumn, EntityListProps } from './hooks';
import { useScreenType, useFm } from '@web3/base-hooks';
import { EntityCard } from './entity-card';
import { TabKey } from './types';

import styles from './index.module.scss';
import { CommonLoading } from '@/components/CommonLoading';

export const EntityList = (props: EntityListProps) => {
  const {
    tabList,
    currentTab,
    tableList,
    handleChangeTab,
    pageNo,
    pageSize,
    onChangePageNo,
    listLength,
    finallyLoading,
  } = useData(props);
  const { cols } = useColumn({ currentTab, pageNo });
  const fm = useFm();
  const { isMobile } = useScreenType();

  return (
    <div className={styles.contanier}>
      <div className={styles.title}>
        {fm('untraceableFreezeableEndPointsReached')}
      </div>
      <div className={styles.desc}>
        {fm('fundReachUntraceableEndpointNotice')}
      </div>
      <div className={styles.content}>
        <Tabs
          size={isMobile ? 'm' : 'xl'}
          items={tabList}
          activeKey={currentTab}
          onChange={handleChangeTab}
        />

        <div className={styles.pc}>
          <CommonLoading loading={finallyLoading}>
            <Table
              columns={cols}
              data={tableList}
              className={clx(styles.table, {
                [styles.bridgeTable]: currentTab === TabKey.BRIDGE,
              })}
            />
          </CommonLoading>
        </div>
        <div className={styles.mobile}>
          {finallyLoading && <CommonLoading loading={finallyLoading} />}
          {!finallyLoading && tableList.length === 0 && (
            <Empty subTitle={fm('noRecords')} />
          )}
          {!finallyLoading && tableList.length > 0 && (
            <>
              {tableList.map((item, index) => (
                <EntityCard
                  currentTab={currentTab}
                  data={item}
                  key={index}
                  pageNo={pageNo}
                  pageSize={pageSize}
                />
              ))}
            </>
          )}
        </div>
        {listLength > pageSize && (
          <Pagination
            current={pageNo}
            total={listLength}
            pageSize={pageSize}
            align="center"
            onChange={(current) => {
              onChangePageNo(current);
            }}
            rootClassName={styles.pagination}
          />
        )}
      </div>
    </div>
  );
};
